import React, { useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import ReactPlayer from "react-player";
import { Box, Typography } from "@mui/material";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import * as mammoth from "mammoth";


const CustomFileViewer = ({ fileUrl, fileType }) => {
  const [textContent, setTextContent] = useState("");
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    if (fileType === "txt" || fileType === "svg") {
      fetch(fileUrl)
        .then((response) => response.text())
        .then((data) => setTextContent(data))
        .catch((error) => console.error("Error loading file:", error));
    }
    if (fileType === "docx") {

      fetch(fileUrl)
        .then((response) => {
          if (!response.ok) throw new Error("Failed to load DOCX file");
          return response.arrayBuffer(); 
        })
        .then((arrayBuffer) => {
          return mammoth.extractRawText({ arrayBuffer });
        })
        .then((result) => {
        
          setTextContent(result.value);
        })
        .catch((error) => console.error("Error processing DOCX file:", error));
    }
  }, [fileUrl, fileType]);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const renderFile = () => {
    switch (fileType.toLowerCase()) {
      case "pdf":
        // pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.min.mjs`;
        pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              overflowY: "auto",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
              {Array.from(new Array(numPages), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={500}
                />
              ))}
            </Document>
          </Box>
        );

      case "docx":
        return textContent ? (
          <Box sx={{ padding: "1rem", maxHeight: "100%", overflowY: "auto" }}>
            <Typography component="pre" style={{ whiteSpace: "pre-wrap" }}>
              {textContent}
            </Typography>
          </Box>
        ) : (
          <Typography>Loading DOCX content...</Typography>
        );

      case "mp4":
      case "webm":
      case "mov":
        return (
          <ReactPlayer url={fileUrl} controls width="100%" height="auto" />
        );

      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return (
          <img
            src={fileUrl}
            alt="preview"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              objectFit: "contain",
            }}
          />
        );

      case "txt":
        return (
          <Typography component="pre" style={{ whiteSpace: "pre-wrap" }}>
            {textContent}
          </Typography>
        );

      case "svg":
        return (
          <Box
            dangerouslySetInnerHTML={{ __html: textContent }}
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              objectFit: "contain",
            }}
          />
        );

      default:
        return <Typography>Unsupported file format</Typography>;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: "#234540",
        height: "85vh",
        width: "591px",
        p: "1rem",
        overflow: "hidden",
      }}
    >
      {renderFile()}
    </Box>
  );
};

export default CustomFileViewer;
